import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

declare let rdt: Function;

@Injectable({
  providedIn: 'root',
})
export class RedditPixelService {
  private isProductionSite =
    window.location.origin === 'https://cleverdeals.net';

  private generateConversionId(): string {
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }

  trackPageVisit(conversionId?: string) {
    if (this.isProductionSite) {
      const eventData = {
        conversion_id: conversionId || this.generateConversionId(),
      };
      rdt('track', 'PageVisit', eventData);
    }
  }

  trackSignUp(customerId?: string, customerEmail?: string) {
    if (this.isProductionSite) {
      const eventData = {
        conversion_id: this.generateConversionId(),
        customerId: customerId,
        customerEmail: customerEmail,
        currency: environment.paymentCurrency,
      };
      rdt('track', 'SignUp', eventData);
    }
  }

  trackPurchase(value?: number, reservationId?: number) {
    if (this.isProductionSite) {
      const eventData: any = {
        conversion_id: this.generateConversionId(),
        reservationId: reservationId,
        currency: environment.paymentCurrency,
      };

      if (value !== undefined) {
        eventData.value = value;
      }
      rdt('track', 'Purchase', eventData);
    }
  }

  trackLead(conversionId?: string) {
    if (this.isProductionSite) {
      const eventData = {
        conversion_id: conversionId || this.generateConversionId(),
      };
      rdt('track', 'Lead', eventData);
    }
  }

  trackAddToCart(
    reservationId?: number,
    customerId?: number,
    dealId?: number,
    value?: number
  ) {
    if (this.isProductionSite) {
      const eventData: any = {
        conversion_id: `ReservationCreated_${this.generateConversionId()}`,
        reservationId: reservationId,
        customerId: customerId,
        currency: environment.paymentCurrency,
        productId: dealId,
        value: value,
      };

      rdt('track', 'AddToCart', eventData);
    }
  }

  trackViewContent(
    contentType?: string,
    contentId?: string,
    conversionId?: string
  ) {
    if (this.isProductionSite) {
      const eventData: any = {
        conversion_id: conversionId || this.generateConversionId(),
      };

      if (contentType) {
        eventData.content_type = contentType;
      }
      if (contentId) {
        eventData.content_id = contentId;
      }

      rdt('track', 'ViewContent', eventData);
    }
  }

  trackCustomEvent(eventName: string, eventData?: any, conversionId?: string) {
    if (this.isProductionSite) {
      const finalEventData = {
        ...eventData,
        conversion_id: conversionId || this.generateConversionId(),
      };
      rdt('track', eventName, finalEventData);
    }
  }
}
